import { useState, useCallback } from 'react';

export type GameState =
  | { step: 'idle' }
  | { step: 'purchasing'; orderId: string }
  | { step: 'failed'; message: string; code?: string };

export function useGameFlow() {
  const [state, setState] = useState<GameState>({ step: 'idle' });
  return {
    state,
    startPurchase: useCallback((orderId: string) => setState({ step: 'purchasing', orderId }), []),
    // `code` is the backend error code when known (INSUFFICIENT_BALANCE …) so
    // the failure UI can offer a targeted action; omitted when unknown.
    fail: useCallback(
      (message: string, code?: string) =>
        setState({ step: 'failed', message, ...(code !== undefined ? { code } : {}) }),
      [],
    ),
    reset: useCallback(() => setState({ step: 'idle' }), []),
  };
}
